import styled from "styled-components";
import { OverlayWrapper } from "common/Overlays/Overlay";
import LongPress from "common/Gestures/LongPress.tsx";
import { useBottomNavigator } from "utils/hooks/misc.tsx";
import {
  HTMLAttributes,
  PropsWithChildren,
  DetailedHTMLProps,
  forwardRef,
  ForwardedRef,
} from "react";
import { phoneMaxWidth } from "common/NewLook/layout.ts";

interface CardProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  onLongPress?: () => void;
}

const Card = forwardRef(
  (
    { onLongPress, children, ...props }: PropsWithChildren<CardProps>,
    ref: ForwardedRef<HTMLDivElement>
  ) => {
    const { baseShouldDisplay: isBottomNavigator } = useBottomNavigator();
    const card = (
      <StyledCard {...props} ref={ref}>
        {children}
      </StyledCard>
    );

    if (!!onLongPress && isBottomNavigator) {
      return <LongPress triggerElement={card} onLongPress={onLongPress} />;
    }

    return card;
  }
);

export default Card;

const StyledCard = styled.div`
  padding: 16px;
  box-shadow: ${(p) => p.theme.shadows.card};
  background-color: ${(p) => p.theme.colors.cardBgColor};
  width: 100%;
  height: auto;
  border-radius: 12px;
  ${(p) =>
    p.theme.isNewLook &&
    `
    border-radius: ${p.theme.radii.card}px;
    box-shadow: ${
      p.theme.isDarkMode
        ? `inset 0 0 0 1px ${p.theme.colors.cardBorderColor}`
        : p.theme.shadows.panel
    };
  `}
  ${OverlayWrapper} {
    background: ${(p) => p.theme.colors.cardBgColor};
  }
  @media (max-width: ${phoneMaxWidth}) {
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
`;
